import { Navigate } from "react-router-dom";
import { useSession } from "@/auth/session";

export function RequireAuth({ children }: { children: React.ReactNode }) {
  const { isAuthenticated } = useSession();
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  return <>{children}</>;
}
